<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-08-26 20:51:12
 * @LastEditors: hayuu
 * @LastEditTime: 2025-04-02 14:47:46
-->
<template>
  <div id="app">
    <router-view v-if="
      $route.path == '/id_copy' ||
      $route.path == '/certificate_copy' ||
      $route.path == '/jzz_copy' ||
      $route.path == '/pkz_copy' ||
      $route.path == '/img_copy' ||
      $route.path == '/sxzw' ||
      $route.path == '/sxzwUser'
    "></router-view>
    <div class="app_page" v-else>
      <h2 @click="$router.push('/')">{{ areaName }}政务自助一体机</h2>
      <div class="nav">
        <p @click="clear">
          {{ currentTime.currentDate }} {{ currentTime.currentTime }}
        </p>
        <div class="nav_right">
          <template v-if="$store.isLogin">
            {{ replaceWord($store.userInfo.userName, 1, "*") }}，{{ noonTip }}
            <img src="@/assets/images/exit_icon.png" alt="" @click="exitShow = true" />
          </template>
          <div class="btn" @click="handleLogin" v-else>登录</div>
        </div>
      </div>
      <div class="body">
        <div class="page_box">
          <div class="page">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>

            <!-- <router-view></router-view> -->
          </div>
        </div>
      </div>
      <!-- <float-button ref="floatButton" @changeClick="goChat" /> -->


      <login ref="login" v-if="$store.loginShow" @loginSuccess="loginSuccess"></login>
      <!-- deppseek -->
      <float-button2 ref="floatButton2" @changeClick="goChat" />
      <!-- <rateDia></rateDia> -->
    </div>

    <alert ref="alert" title="提示" content="确定要退出吗？" @confirm="handleExit" @cancel="
      () => {
        exitShow = false;
      }
    " :showCancelButton="false" v-if="exitShow">
    </alert>

    <areaDia v-if="areaShow" @submit="handleAreaSubmit"></areaDia>
  </div>
</template>

<script>
import areaDia from "@/components/areaDia";
import { getCurrentTime } from "@/utils/currentTime";
import floatButton from "./components/floatButton";
import floatButton2 from "./components/floatButton2";
import { getCurrentUser } from "@/utils/auth";
export default {
  name: "App",
  components: {
    areaDia,
    floatButton,
    floatButton2,
  },
  data() {
    return {
      loginShow: false,
      currentTime: {},
      timer: null,
      userInfo: {},
      noonTip: "",

      exitShow: false,

      areaShow: false,

      areaName: "",

      clickLogs: [],
    };
  },
  created() {
    /** 地市 -- 临猗 */
    // localStorage.setItem('area', JSON.stringify({
    //   "name": "临猗县",
    //   "code": "140821000000",
    //   "type": 1,
    //   "pid": "0"
    // }))
    // localStorage.setItem('areaName', '临猗县')
    // this.$set(this, "areaName", '临猗县')

    /** 地市 -- 岢岚 */
    // localStorage.setItem('area', JSON.stringify({
    //   "name": "岢岚县",
    //   "code": "140929000000",
    //   "type": 1,
    //   "pid": "0"
    // }))
    // localStorage.setItem('areaName', '岢岚县')
    // this.$set(this, "areaName", '岢岚县')

    /** 地市 -- 其他 */
    if (!localStorage.getItem("area")) {
      this.areaShow = true;
    }
    if (localStorage.getItem("areaName")) {
      this.areaName = localStorage.getItem("areaName");
    }

    if (getCurrentUser()) {
      this.userInfo = getCurrentUser();
    }
  },
  mounted() {
    this.currentTime = getCurrentTime();
    this.timer = setInterval(() => {
      this.myNoonTip();
      this.currentTime = getCurrentTime(); // 每秒更新一次时间
    }, 1000);
    // this.initScroll()
  },
  methods: {
    goChat() {
      console.log("智能问答");
    },
    handleLogin() {
      this.$store.dispatch("LogOut").then((res) => {
        this.$store.loginShow = true;
      })
    },
    handleAreaSubmit(area, name) {
      this.areaShow = false;
      localStorage.setItem("area", area);
      localStorage.setItem("areaName", name);
      this.$set(this, "areaName", name);
    },
    loginSuccess() {
      this.$store.loginShow = false;
      if (localStorage.getItem("goUrl")) {
        let goUrl = localStorage.getItem("goUrl");
        localStorage.removeItem("goUrl");
        this.$router.push({
          path: goUrl
        });
      }
    },

    handleExit() {
      console.log("tuichu");
      this.$refs.cancelButtonLoading = true;
      this.$store.dispatch("LogOut").then((res) => {
        this.$refs.cancelButtonLoading = false;
        this.exitShow = false;
      });
    },

    replaceWord(str, index, newWords) {
      let arr = str.split("");
      arr[index] = newWords;
      return arr.join("");
    },

    myNoonTip() {
      const that = this;
      const date = new Date();
      const hour = date.getHours();
      // console.log('现在时间是:' + hour + '点!');
      if (hour >= 0 && hour < 12) {
        that.noonTip = "上午好";
      } else if (hour === 12) {
        that.noonTip = "中午好";
      } else if (hour > 12 && hour < 18) {
        that.noonTip = "下午好";
      } else {
        that.noonTip = "晚上好";
      }
    },

    clear() {
      this.clickLogs.push(new Date().getTime());
      if (this.clickLogs.length > 10) {
        this.clickLogs.splice(0, 1);
      }
      if (this.clickLogs.length === 10) {
        if (this.clickLogs[9] - this.clickLogs[0] < 5000) {
          this.clickLogs.splice(0, 10);
          // 你的触发事件
          var storage = localStorage;
          storage.clear();
          this.$router.go(0);
        }
      }
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: PingFangSC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}

input:focus-visible {
  outline: none;
}

// ::-webkit-scrollbar {
//   width: 6px;
//   height: 6px;
// }

// ::-webkit-scrollbar-thumb {
//   background: #E7E7E7;
//   border-radius: 5px 5px 5px 5px;
// }

// ::-webkit-scrollbar-track {
//   border-radius: 0;
//   background: #F6F6F6;
// }

.cascader {
  z-index: 2030;
}

.app_page {
  position: relative;
  overflow: hidden;
  width: 1920px;
  height: 1080px;
  background-image: url("@/assets/images/bg.png");

  >h2 {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 600;
    font-size: 38px;
    color: #0860f2;
    line-height: 53px;
  }

  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 101px;
    padding: 40px 40px 0;
    background-image: url("@/assets/images/nav_bg.png");
    background-size: 100% 100%;
    border-radius: 0px 0px 0px 0px;

    p {
      font-size: 26px;
      color: #ffffff;
      line-height: 36px;
      font-style: normal;
      text-transform: none;
    }

    .nav_right {
      display: flex;
      align-items: center;
      font-family: PingFangSC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      line-height: 34px;
      text-align: center;

      img {
        width: 30px;
        height: 30px;
        margin-left: 8px;
      }

      .btn {
        width: 160px;
        height: 56px;
        background: #ffffff;
        border-radius: 32px 32px 32px 32px;
        font-size: 24px;
        color: #3f87ff;
        line-height: 56px;
        text-align: center;
      }
    }
  }

  .body {
    width: 100%;
    height: calc(100% - 96px);
    padding: 35px 40px 40px;

    .page_box {
      width: 100%;
      height: 100%;
      padding: 4px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 20px 20px 20px 20px;

      .page {
        display: flex;
        width: 100%;
        height: 100%;
        background: rgba(243, 249, 255, 1);
        border-radius: 20px 20px 20px 20px;
      }
    }
  }
}

::v-deep .el-picker-panel {
  .cell {
    font-size: 20px;
  }
}
</style>
